export default __webpack_public_path__ + "static/media/SteelsTableImg2.1ca0221e.jpg";